import { Position } from '@flipster/r230522/original/position';
import { createStepComponent } from '@flipster/react/misc/step/Steps';
import { useSteps } from '@flipster/react/misc/step/use-steps';

import { ModalErrorBoundary } from '../../../utils/modal-error-boundary';
import { MovableModalLegacy } from '../../movable-modal';
import { AboutProfitBoostStep } from './about-profit-boost-step';
import { ConfirmProfitBoostStep } from './confirm-profit-boost-step';

interface Props {
  symbol: string;
  positionId: Position['positionId'];
  location: 'assets_tab' | 'order_form_page'; // only for logging
  isOpen: boolean;
  onClose: () => void;
}

type Steps = {
  about: undefined;
  confirm: undefined;
};

const Steps = createStepComponent();

export const ProfitBoostModal = ({ symbol, positionId, location, isOpen, onClose }: Props) => {
  const { current, push } = useSteps<Steps>({
    initialValue: { step: 'about', context: undefined },
  });

  return (
    <MovableModalLegacy.Root isOpen={isOpen} onClose={onClose} size='small' scrollable>
      <ModalErrorBoundary onError={onClose}>
        <Steps model={current}>
          <Steps.Step step='about'>
            {() => (
              <AboutProfitBoostStep
                symbol={symbol}
                positionId={positionId}
                location={location}
                onNext={() => {
                  push({ step: 'confirm', context: undefined });
                }}
              />
            )}
          </Steps.Step>
          <Steps.Step step='confirm'>
            {() => (
              <ConfirmProfitBoostStep onClose={onClose} symbol={symbol} positionId={positionId} location={location} />
            )}
          </Steps.Step>
        </Steps>
      </ModalErrorBoundary>
    </MovableModalLegacy.Root>
  );
};
